<button
  class="button-toggle"
  [class]="active ? 'active' : ''"
  type="button"
  (click)="onToggleMenu()"
>
  <span class="button-toggle__bar"></span>
</button>
